<template>
    <div>
        <div v-if="feedbacksLoading" class="d-flex justify-content-center">
            <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
        </div>

        <!-- CARDS -->
        <div v-else>
            <div v-if="feedbacks.length == 0"><h4>Sem feedbacks</h4></div>
            <div v-else class="card" v-for="(feedback, index) in feedbacks" :key="index" style="width: 26em;">
                <div class="card-body">
                    <template>
                        <div class="text-left">
                            <div class="mb-3">
                                <h5 class="card-text text-primary">{{ feedback.aluno.nome }}</h5>
                            </div>
                            <div>
                                <div class="row">
                                    <div class="col">
                                        <h6>Qualidade do meterial: </h6>
                                        <div class="d-flex mt-3">
                                            <h6 class="card-title mr-3" v-for="notaQualidadeMaterial in feedback.qualidade_material" :key="notaQualidadeMaterial.index">
                                                <i class="fa fa-star fa-lg text-primary mb-3"></i>
                                            </h6>
                                            <div class="d-flex" v-if="feedback.qualidade_material < 5">
                                                <h6 class="card-title mr-3" v-for="notaQualidadeMaterial in ((feedback.qualidade_material - 5) * -1)" :key="notaQualidadeMaterial.index">
                                                    <i class="fa fa-star-o fa-lg mb-3"></i>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <h6>Professor: </h6>
                                        <div class="d-flex mt-3">
                                            <h6 class="card-title mr-3" v-for="notaProfessor in feedback.professor" :key="notaProfessor.index">
                                                <i class="fa fa-star fa-lg text-primary mb-3"></i>
                                            </h6>
                                            <div class="d-flex" v-if="feedback.professor < 5">
                                                <h6 class="card-title mr-3" v-for="notaProfessor in ((feedback.professor - 5) * -1)" :key="notaProfessor.index">
                                                    <i class="fa fa-star-o fa-lg mb-3"></i>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <h6>Áudio: </h6>
                                        <div class="d-flex mt-3">
                                            <h6 class="card-title mr-3" v-for="notaAudio in feedback.audio" :key="notaAudio.index">
                                                <i class="fa fa-star fa-lg text-primary mb-3"></i>
                                            </h6>
                                            <div class="d-flex" v-if="feedback.audio < 5">
                                                <h6 class="card-title mr-3" v-for="notaAudio in ((feedback.audio - 5) * -1)" :key="notaAudio.index">
                                                    <i class="fa fa-star-o fa-lg mb-3"></i>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <h6>Vídeo: </h6>
                                        <div class="d-flex mt-3">
                                            <h6 class="card-title mr-3" v-for="notaVideo in feedback.video" :key="notaVideo.index">
                                                <i class="fa fa-star fa-lg text-primary mb-3"></i>
                                            </h6>
                                            <div class="d-flex" v-if="feedback.video < 5">
                                                <h6 class="card-title mr-3" v-for="notaVideo in ((feedback.video - 5) * -1)" :key="notaVideo.index">
                                                    <i class="fa fa-star-o fa-lg mb-3"></i>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h5 class="text-primary">Descrição:</h5>
                                <p class="card-text">{{ feedback.descricao }}</p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <!-- FIM CARDS -->
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import TurmasController from './TurmasController'

export default {
  name: 'TableFeedbacks',
  components: {
    ...spinners,
  },
  props: {
    idTurma: Number,
  },
  data () {
    return {
      feedbacks: [],
      feedbacksLoading: false,
    }
  },
  methods: {
    loadData () {
      const data = {
        turma: this.idTurma
      }

      this.loadFeedbacks(data)
    },

    loadFeedbacks (data) {
      this.feedbacksLoading = true

      TurmasController.getFeedbacks(data, (response) => {
        if (response.sucesso === true) {
          this.feedbacks = response.dados

          this.feedbacksLoading = false
        } else {
          TurmasController.launchToast('fa fa-warning', response.mensagem)

          this.feedbacksLoading = false
        }
      })
    }
  },
  mounted () {
    this.loadData()
  },
}
</script>
